import React, { useState, useEffect } from 'react';
import Button from '../../../../../../../../components/atomic/Button';
import {
  fetchConsents as apiFetchConsents,
  updateConsents as apiUpdateConsents,
} from '../../../../../../../../api/propertyowners';
import { PROPERTYVALUEESTIMATEUPDATES } from '../../../../../../../../constants';
import useSnackbar from '../../../../../../../../hooks/useSnackbar';
import useFetchEffect from '../../../../../../../../hooks/useFetchEffect';
import { useConsentStyles } from './style';

export function ValueEstimateConsent() {
  const classes = useConsentStyles();
  const { showSuccessMessage, showErrorMessage } = useSnackbar();
  const [requestInProgress, setRequestInProgress] = useState(false);
  const [consents, setConsents] = useState(null);
  const [showConsentButton, setShowConsentButton] = useState(false);

  useFetchEffect({
    initialFetchingState: true,
    apiFetchFunction: apiFetchConsents,

    onSuccess: (consentsData) => {
      setConsents(consentsData);
    },
  });

  useEffect(() => {
    if (consents) {
      const valueEstimateEmailConsent = consents.find(
        (consent) => consent.type === PROPERTYVALUEESTIMATEUPDATES
      );
      const isEmailConsentGranted = valueEstimateEmailConsent?.isGranted;

      setShowConsentButton(!isEmailConsentGranted);
    }
  }, [consents]);

  const onConsentButtonSubmit = async () => {
    setRequestInProgress(true);

    const updatedConsent = [
      { type: PROPERTYVALUEESTIMATEUPDATES, isGranted: true },
    ];

    const [error, response] = await apiUpdateConsents(updatedConsent);
    if (error && !response) {
      showErrorMessage();
    } else {
      showSuccessMessage();
      setShowConsentButton(false);
    }

    setRequestInProgress(false);
  };

  return (
    <div className={classes.consentContainer}>
      {showConsentButton && (
        <>
          <p className={classes.valueEstimateConsentText}>
            Motta månedlig varsel på e-post med oppdatert prisestimat for
            eiendommen.
          </p>
          <Button
            color="primary"
            variant="contained"
            disabled={requestInProgress}
            onClick={onConsentButtonSubmit}
            className={classes.consentButton}
          >
            Hold meg oppdatert
          </Button>
          <br />
          <br />
        </>
      )}

      {!showConsentButton && (
        <>
          <p className={classes.valueEstimateTextTop}>
            Du mottar månedlig varsel på epost med oppdatert prisestimat.
          </p>
          <p className={classes.valueEstimateTextBottom}>
            *Dette kan endres under «Administrer samtykker»
          </p>
        </>
      )}
    </div>
  );
}
